import PopUp from '../../../../Shared/Popup/PopUp';
import React, {useEffect, useState} from 'react';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import BtnWhiteBlackBorderSmallSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {isMobile} from 'react-device-detect';
import {androidSVG, iosSVG, stageEnums} from '../../Assets/VolteCheckVariables';
import {buildUrlAndOpenWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import InstallSign from '../../Assets/SVG/InstallSign';

const InactiveStage = (props) => {
  const disclaimerText = isMobile ? (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע <br />
      המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו <br />
      מובטח כמדויק בכל עת. על מנת לבדוק אם מכשירך מתאים <br />
      ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע המעודכן והאמין ביותר, <br />
      אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל עת. על מנת לבדוק אם <br />
      מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );

  return (
    <>
      <PopUp
        showPopUp={true}
        onClose={() => {
          if (props.subscribersByProduct?.Cellular?.length > 1) {
            props.setStage(stageEnums.selectSubscriber);
          } else {
            buildUrlAndOpenSameWindow(Config.staticWebSiteUrl);
          }
        }}>
        <div className='headBox'>
          <p className='heading'>
            מעולה,
            <br />
            המכשיר שלך תומך
          </p>
          <p className='subHeading mb-32' style={{color: 'var(--theme-primary, #9631ff)'}}>
            יש לעדכן את הגדרות המכשיר
          </p>
          <InstallSign className={'mb-32'} />
        </div>
        <div className='headBox' style={{marginBottom: '12px'}}>
          <p className='subHeading' style={{marginBottom: '0px'}}>
            למעבר להוראות הפעלה במכשיר
          </p>
        </div>
        <div className='installationGuides'>
          <BtnWhiteBlackBorderSmallSize
            svgImage={androidSVG}
            text={'אנדרואיד'}
            onclick={() => {
              buildUrlAndOpenWindow(props.iContent.androidGuideUrl?.value);
            }}
          />
          <BtnWhiteBlackBorderSmallSize
            svgImage={iosSVG}
            text={'iOS'}
            onclick={() => {
              buildUrlAndOpenWindow(props.iContent.iosGuideUrl?.value);
            }}
          />
        </div>
        {props.subscribersByProduct?.Cellular?.length > 1 && (
          <div className='mb-12'>
            <BtnWhiteBlackBorderBigSize
              text={'חזרה לבחירת מנוי'}
              onclick={() => {
                props.setStage(stageEnums.selectSubscriber);
              }}
            />
          </div>
        )}
        {disclaimerText}
      </PopUp>
    </>
  );
};

export default InactiveStage;
